import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { PickupService } from '@checkout-v2/feature';
import { MyShopService } from '@my-shop/feature';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { ShopListService } from '@shop/feature';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PickupState } from './pickup-address.model';

@Component({
  selector: 'sd-pickup-address',
  templateUrl: './pickup-address.component.html',
  styleUrls: ['./pickup-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPickupAddressComponent implements OnInit {
  private readonly pickupService = inject(PickupService);
  private readonly myShopService = inject(MyShopService);
  private readonly shopListService = inject(ShopListService);

  protected readonly iconType = CUSTOM_ICON_TYPE;
  protected state = PickupState;
  protected state$: Observable<PickupState>;

  ngOnInit(): void {
    this.state$ = combineLatest({
      pickupShop: this.pickupService.activeShop$,
      noPosAvailable: this.shopListService.noPosAvailable$,
      shops: this.shopListService.shops$,
      myShop: this.myShopService.activeShop$,
    }).pipe(
      map(({ pickupShop, noPosAvailable, shops, myShop }) => {
        if (noPosAvailable) {
          return this.state.NoPosAvailable;
        }

        if (pickupShop && shops && shops.some((shop) => shop.name === pickupShop.name)) {
          if (shops.length === 1) {
            return this.state.ShowPosOnlyOne;
          }

          return this.state.ShowPos;
        }

        if (myShop && shops && !shops.some((shop) => shop.name === myShop.name)) {
          return this.state.ShowPosNotAvailable;
        }

        return this.state.AddPos;
      }),
    );
  }
}
